<div class="card mb-5">
	<div class="card-header">
		<h3>Histórico de Cotizaciónes <a routerLink="/sales/invoice" class="clickeable"
				style="text-decoration: none;">
				<span class="sp-con-default">
					<i class="fa-solid fa-circle-plus"></i>
					<i style="color: var(--bs-bg-servicios);" class="bx bx-detail sp-el-default"></i>
				</span>
				<span>
					Nueva Cotización
				</span>
			</a>
		</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<h5>Filtrar</h5>
				<div class="row g-3 mb-3">
					<div class="col-md-3">
						<label class="form-label">Estado</label>
						<select
						[(ngModel)]="quotationStatus"
						(change)="changeQuotationStatus()"
						class="form-select">
						<option value="ACTIVE">Activas</option>
						<option value="OVERDUE">Vencidas</option>
						</select>
					</div>

					<div class="col-md-5">
						<label class="form-label">Bodega</label>
						<select
						[(ngModel)]="warehouse"
						(change)="updateFilter()"
						class="form-select">
						<option [ngValue]="null">Todas</option>
						<option *ngFor="let warehouse of warehouseList"
								[ngValue]="warehouse.id">
							{{warehouse.name}}
						</option>
						</select>
					</div>

					<div class="col-md-4">
						<label class="form-label">Orden</label>
						<select
						[(ngModel)]="isAscendent"
						(change)="changeOrder()"
						class="form-select">
						<option value="0">Ascendente</option>
						<option value="1">Descendente</option>
						</select>
					</div>
				</div>
				<div class="row g-3 align-items-end">
					<div class="col-md-2">
						<label class="form-label">Fecha inicio</label>
						<input
						type="date"
						[(ngModel)]="startDate"
						(change)="changeDateFilter()"
						class="form-control">
					</div>

					<div class="col-md-2">
						<label class="form-label">Fecha fin</label>
						<input
						type="date"
						[(ngModel)]="endDate"
						(change)="changeDateFilter()"
						class="form-control">
					</div>

					<div class="col-md-8">
						<label class="form-label">Buscar cotización</label>
						<div class="input-group">
						<input
							type="text"
							[(ngModel)]="search"
							placeholder="Código, NIT o nombre"
							class="form-control">

						<button
							class="btn btn-primary"
							(click)="updateFilter()">
							<i class="fa fa-search"></i>
						</button>
						</div>
					</div>

				</div>
				<div class="table-responsive" [class.table-responsive-without]="waitingFor && !seeingAnulate"
					style="margin-bottom: 0;">
					<table class="table table-striped" style="margin-bottom: 0;">
						<thead>
							<tr class="tr-middle">
								<th class="ta">
									Código
								</th>
								<th class="ta">
									Cliente
								</th>
								<th class="ta">
									Bodega
								</th>
								<th class="ta">
									Total
								</th>
								<th class="ta">
									Fechas
								</th>
								<th class="ta">
									Descripción
								</th>
								<th class="ta">
									Afiliado
								</th>
								<th class="ta">
									Puntos
									<br style="margin: 0;">
									Esperados
								</th>
								<th class="ta">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th class="ta th-balance" [class.balance-success]="total>=0" colspan="9">Total
									{{total | currency:'Q'}}</th>
							</tr>
							<ng-container *ngFor="let invoice of pagination.filter">
								<tr [class.hide-all]="waitingFor?.id==invoice.id && !seeingAnulate" class="tr-middle">
									<td class="ta">
										{{invoice.id}}
									</td>
									<td class="ta">
										<p class="date-title">
											{{invoice.nit}}
										</p>
										<p class="date-field">NIT</p>
										<p class="date-title">
											{{invoice.name}}
										</p>
										<p class="date-field text-danger">Nombre</p>
									</td>
									<td class="ta">
										<ng-container
											*ngIf="warehouseNames !== {} && warehouseNames[invoice.warehouse]">
											{{warehouseNames[invoice.warehouse].name}}
										</ng-container>
									</td>
									<td class="ta">
										{{(invoice.totalCost) | currency : ((invoice.currency==1)?"$. ":"Q. ")}}
									</td>
									<td class="ta">
										<p class="date-title">
											{{convertToString(invoice.creationDate)}}
										</p>
										<p class="date-field">Creación</p>
										<p class="date-title text-danger">
											{{convertToString(invoice.deadline)}}
										</p>
										<p class="date-field text-danger">Vencimiento</p>
									</td>
									<td class="ta">
										<ng-container *ngIf="invoice.description">
											{{invoice.description}}
										</ng-container>
										<ng-container *ngIf="!invoice.description">
											<span class="opacity-30"><i class="fa fa-circle-info"></i>Sin
												descripción.</span>
										</ng-container>
									</td>
									<td class="ta">
										<ng-container *ngIf="invoice.affiliate">
											{{invoice.affiliate}}
										</ng-container>
										<ng-container *ngIf="!invoice.affiliate">
											<span class="opacity-30"><i class="fa fa-circle-info"></i>Sin
												afiliado.</span>
										</ng-container>
									</td>
									<td class="ta">
										{{invoice.pointsAffiliate}}
									</td>
									<td class="ta">
										<ng-container *ngIf="quotationStatus === 'ACTIVE'; else overdueActions">
											<div style="display: flex; justify-content: space-between;">
											<!-- <span (click)="factCot(invoice)" class="clickeable text-info" title="Facturar al Credito">
												<span *ngIf="!loadingCheckIn[invoice.id]" class="superposition-container">
												<i class="fa fa-receipt"></i>
												<i class="fa-solid fa-arrows-rotate superposition-element"></i>
												</span>
												<span *ngIf="loadingCheckIn[invoice.id]" class="spinner-border spinner-border-sm"></span>
												<small>Crédito</small>
											</span>

											<span (click)="factCotCash(invoice)" class="clickeable text-info" title="Facturar con caja">
												<span *ngIf="!loadingCheckIn[invoice.id]" class="superposition-container">
												<i class="fa fa-cash-register"></i>
												<i class="fa-solid fa-arrow-right superposition-element"></i>
												</span>
												<span *ngIf="loadingCheckIn[invoice.id]" class="spinner-border spinner-border-sm"></span>
												<small>Caja</small>
											</span> -->

											<span tooltip="Descargar" *ngIf="!loadingDownload[invoice.id]"
												(click)="getQuotationPDF(invoice)" class="clickeable text-info">
												<i class="fa fa-download"></i>
											</span>

											<span *ngIf="loadingDownload[invoice.id]" class="spinner-border spinner-border-sm"></span>

											<div class="container-superposition" title="Eliminar">
												<div class="element-superposition" *ngIf="waitingFor?.id == invoice.id">
												<span>¿Está seguro que desea eliminar esta cotización?</span>
												<span class="a-container">
													<span class="a-hover" (click)="resetDeletingDiv()">
													<i class="fa fa-ban"></i>NO
													</span>
													<span class="a-hover text-danger" (click)="confirmDelete(invoice)">
													<i class="fa fa-trash"></i>SÍ
													</span>
												</span>
												</div>

												<span class="clickeable text-danger" (click)="deleteCot(invoice)">
												<i *ngIf="!deleting[invoice.id]" class="fa fa-trash"></i>
												<span *ngIf="deleting[invoice.id]" class="spinner-border spinner-border-sm"></span>
												</span>
											</div>
											</div>
										</ng-container>

										<ng-template #overdueActions>
											<span tooltip="Descargar" *ngIf="!loadingDownload[invoice.id]"
											(click)="getQuotationPDF(invoice)" class="clickeable text-info">
											<i class="fa fa-download"></i>
											<small> Descargar</small>
											</span>

											<span *ngIf="loadingDownload[invoice.id]" class="spinner-border spinner-border-sm"></span>
										</ng-template>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="pagination.filter.length == 0">
								<td colspan="8" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>No se encontraron documentos en las fechas
									seleccionadas
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
</div>
<div class="hide-background" *ngIf="waitingFor">
	<div class="for-click" (click)="resetDeletingDiv()"></div>
</div>
<app-simple-modal [max]="50" (close)="hideTokenAuthorization()" [title]="'AUTORIZACIÓN'" *ngIf="invoiceTemp">
	<div fields>
		<div class="input-group">
			<label for="token" class="input-group-text">Token <i class="fa fa-asterisk text-danger"></i></label>
			<input type="text" placeholder="Ingresa un token de autorización" id="token" name="token"
				[(ngModel)]="token" class="form-control">
		</div>
	</div>
	<div buttons>
		<app-loading-button [logo]="true" [colorLoading]="'white'" [disabled]="!token" [object]="tokenButton"
			(clicked)="validateToken()"></app-loading-button>
	</div>
</app-simple-modal>

<app-simple-modal
  [max]="50"
  (close)="hideCashModal()"
  [title]="'FACTURACION CON CAJA'"
  *ngIf="invoiceTempCash"
>
  <div fields>
    <div class="input-group mb-3">
      <label for="cashier" class="input-group-text">
        Caja <i class="fa fa-asterisk text-danger"></i>
      </label>
      <select
        id="cashier-input"
        name="cashier"
        [(ngModel)]="selectedCashier"
        class="form-control"
      >
        <option
          *ngFor="let cashier of filterCashiers"
          [value]="cashier.id"
        >
          {{ cashier.name }}
        </option>
      </select>
    </div>
  </div>

  <div buttons>
    <app-loading-button
      [logo]="true"
      [colorLoading]="'white'"
      [disabled]="!selectedCashier"
      [object]="cashButton"
      (clicked)="validateFactCotCash()"
    ></app-loading-button>
  </div>
</app-simple-modal>
